import { traverse } from './traverse';

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function map(adf, callback) {
  var result = [];
  traverse(adf, {
    any: function any(node) {
      result.push(callback(node));
    }
  });
  return result;
}